export default "__VITE_ASSET__DzBZL9g5__"